import { SettingsModal, SETTINGS_TABS } from "./index";
import { PrivacyPanel } from "./PrivacyPanel";

// Route element for /settings/privacy.
export const PrivacySettings = () => (
  <SettingsModal active={SETTINGS_TABS.PRIVACY}>
    <PrivacyPanel />
  </SettingsModal>
);
